export default __webpack_public_path__ + "static/media/dyc_logo_only.807e6e60.png";